module.exports = __webpack_public_path__ + "d915ad8246de953887da860cf4563cef.png";